import { commonTypes } from '../common';

export const types = {

};

export const initialState = {
  poptSelected: null,
};

const UINeedsPaymentReducer = (state, action) => {
  switch (action.type) {
    case commonTypes.SET_POPT_SELECTED: {
      const { poptSelected } = action.payload;
      const newState = {
        ...state,
        poptSelected: poptSelected.id,
      };
      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {

};

export default UINeedsPaymentReducer;
